export default {
  // Common operations
  'common.query': '查询',
  'common.reset': '重置',
  'common.add': '新增',
  'common.edit': '修改',
  'common.delete': '删除',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.export': '导出',
  'common.import': '导入',
  'common.select': '请选择',
  'common.input': '请输入',
  'common.yes': '是',
  'common.no': '否',
  'common.enable': '启用',
  'common.disable': '禁用',
  'common.status': '状态',
  'common.operation': '操作',
  'common.required': '此字段为必填项',
  'common.collapse': '收起',
  'common.expand': '展开',
  'common.addSuccess': '新增成功',
  'common.updateSuccess': '修改成功',
  'common.updateFail': '修改失败',
  'common.deleteSuccess': '删除成功',
  'common.startTime': '开始时间',
  'common.endTime': '结束时间',
  'common.more': '更多',
  'common.sort': '排序',
'video.status': '状态',
'video.sortDesc': '排序',
'video.orderBySort': '按排序查询',
'video.more': '更多',
'video.operation': '操作',
  // Table related
  'table.index': '序号',
  'table.id': 'ID',
  'table.createTime': '创建时间',
  'table.updateTime': '更新时间',
  'table.sort': '排序',
  'table.total': '共 {total} 条',
  'table.default': '默认',
  'table.middle': '中等',
  'table.small': '紧凑',
  'table.columnDisplay': '列展示/排序',
  'table.columnSortTip': '列排序需拖动名称',

  // Setting drawer related
  'setting.overallStyle': '整体风格设置',
  'setting.darkMenu': '暗色菜单风格',
  'setting.lightMenu': '亮色菜单风格',
  'setting.themeColor': '主题色',
  'setting.navMode': '导航模式',
  'setting.sidebarNav': '侧边栏导航',
  'setting.topNav': '顶部栏导航',
  'setting.contentWidth': '内容区域宽度',
  'setting.contentWidthTip': '该设定仅 [顶部栏导航] 时有效',
  'setting.fixed': '固定',
  'setting.fluid': '流式',
  'setting.fixedHeader': '固定 Header',
  'setting.fixedSidebar': '固定侧边菜单',
  'setting.hideFooter': '隐藏 Footer',
  'setting.multiTab': '多页签模式',
  'setting.tableStyle': '表格通用样式',
  'setting.tableSize': '表格大小',
  'setting.showBorder': '显示边框',
  'setting.otherSettings': '其他设置',
  'setting.colorWeak': '色弱模式',
  'setting.copySettings': '拷贝设置',
  'setting.copySuccess': '复制完毕',
  'setting.copyFailed': '复制失败',

  // MultiTab related
  'tab.closeCurrent': '关闭当前标签',
  'tab.closeRight': '关闭右侧',
  'tab.closeLeft': '关闭左侧',
  'tab.closeAll': '关闭全部',
  'tab.lastTabCannotClose': '这是最后一个标签了, 无法被关闭',
  'tab.noLeftTabs': '左侧没有标签',
  'tab.noRightTabs': '右侧没有标签',

  // Video related
  'video.videoName': '剧名',
  'video.videoNameIn': '剧名(中文)',
  'video.videoNameAr': '剧名(阿拉伯)',
  'video.videoNameEn': '剧名(英文)',
  'video.videoNameCn': '剧名(法语)',
  'video.isRelease': '上映状态',
  'video.category': '分类',
  'video.tag': '标签',
  'video.noTag': '无标签',
  'video.new': 'NEW',
  'video.hot': 'HOT',
  'video.premiere': '首播',
  'video.exclusive': '独播',
  'video.enable': '启用',
  'video.disable': '封禁',
  'video.edit': '编辑',
  'video.add': '添加',
  'video.coverUrlIn': '封面图(中文)',
  'video.coverUrlEn': '封面图(英文)',
  'video.coverUrlCn': '封面图(法语)',
  'video.coverUrl': '封面图(阿拉伯)',
  'video.totalNum': '总集数',
  'video.diamondPrice': '每集金币价格',
  'video.releaseTime': '上映时间',
  'video.upload': '上传',
  'video.uploadImage': '请上传图片',
  'video.uploadFailed': '上传失败，请重试',
  'video.confirmDelete': '确认删除所选中数据?',
  'video.confirmDeleteContent': '当前选中编号为',
  'video.confirmExport': '是否确认导出?',
  'video.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'video.inputVideoNameIn': '请输入剧名(中文)',
  'video.inputVideoNameEn': '请输入剧名(英文)',
  'video.inputVideoNameCn': '请输入剧名(法语)',
  'video.inputVideoName': '请输入剧名(阿拉伯)',
  'video.videoNameRequired': '剧名(阿拉伯)不能为空',
  'video.videoNameEnRequired': '剧名(英文)不能为空',
  'video.videoNameCnRequired': '剧名(法语)不能为空',
  'video.videoNameInRequired': '剧名(中文)不能为空',
  'video.coverUrlRequired': '封面图(阿拉伯)不能为空',
  'video.coverUrlEnRequired': '封面图(英文)不能为空',
  'video.coverUrlCnRequired': '封面图(法语)不能为空',
  'video.coverUrlInRequired': '封面图(中文)不能为空',
  'video.totalNumRequired': '总集数不能为空',
  'video.freeLimitNumRequired': '前多少集可以免费观看不能为空',
  'video.freeLimitNumExceed': '前多少集可以免费观看不能大于总集数',
  'video.diamondPriceLessThanDiscount': '每集金币价格不能小于每集金币价格(优惠价格)',
  'video.discountPriceGreaterThanDiamond': '每集金币价格(优惠价格)不能大于每集金币价格',
  'video.releaseTimeRequired': '请选择上映时间',
  'video.releaseTimeBeforeNow': '上映时间不能早于当前时间',
  'video.introductionsMaxLength': '简介最多500字',
  'video.episodeManage': '剧集管理',
  'video.performerList': '演员列表',
  'video.inputTotalNum': '请输入总集数',
  'video.selectTag': '请选择标签',
  'video.no': '无标签',
  'video.selectCategory': '请选择分类',
  'video.freeLimitNum': '前多少集可以免费观看',
  'video.freeSecond': '前多少秒可以免费观看',
  'video.adUnlockEnabled': '第三方广告解锁',
  'video.adUnlockHint': '开启后，本剧未解锁剧集可通过观看第三方广告解锁，无需绑定广告。',
  'video.discountPrice': '每集金币价格(优惠价格)',
  'video.introductionsIn': '简介(中文)',
  'video.introductionsEn': '简介(英文)',
  'video.introductionsCn': '简介(法语)',
  'video.introductions': '简介(阿拉伯)',
  'video.inputIntroductionsIn': '请输入简介(中文)',
  'video.inputIntroductionsEn': '请输入简介(英文)',
  'video.inputIntroductionsCn': '请输入简介(法语)',
  'video.inputIntroductions': '请输入简介(阿拉伯)',
  'video.exportFileName': '短剧',

  // Video performer related
  'videoPerformer.performerNameDe': '演员姓名',
  'videoPerformer.performerNameEn': '演员姓名(英文)',
  'videoPerformer.performerNameFr': '演员姓名(法语)',
  'videoPerformer.performerName': '演员姓名(阿拉伯)',
  'videoPerformer.performerAvatar': '演员头像',
  'videoPerformer.inputPerformerNameDe': '请输入演员姓名',
  'videoPerformer.inputPerformerNameEn': '请输入演员姓名(英文)',
  'videoPerformer.inputPerformerNameFr': '请输入演员姓名(法语)',
  'videoPerformer.inputPerformerName': '请输入演员姓名(阿拉伯)',
  'videoPerformer.inputSort': '请输入排序',
  'videoPerformer.performerNameDeRequired': '演员姓名不能为空',
  'videoPerformer.performerNameEnRequired': '演员姓名(英文)不能为空',
  'videoPerformer.performerNameFrRequired': '演员姓名(法语)不能为空',
  'videoPerformer.performerNameRequired': '演员姓名(阿拉伯)不能为空',
  'videoPerformer.performerAvatarRequired': '演员头像不能为空',
  'videoPerformer.confirmDelete': '确认删除所选中数据?',
  'videoPerformer.confirmDeleteContent': '当前选中编号为',
  'videoPerformer.confirmExport': '是否确认导出?',
  'videoPerformer.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'videoPerformer.exportFileName': '视频演员',

  // App image related
  'appImg.tagName': 'app首页底部标签名',
  'appImg.imgUrl': '点击显示图片',
  'appImg.imgUrlNo': '未点击显示图片',
  'appImg.exportFileName': 'app首页底部tag图片',

  // Barrage related
  'barrage.nickname': '用户昵称',
  'barrage.videoName': '短剧名称',
  'barrage.serialNumber': '集数',
  'barrage.content': '弹幕内容',
  'barrage.commentTime': '评论时间',
  'barrage.inputNickname': '请输入用户昵称',
  'barrage.inputVideoName': '请输入短剧名称',
  'barrage.inputContent': '请输入弹幕内容',
  'barrage.exportFileName': '用户弹幕',

  // Search term related
  'search.content': '搜索词',
  'search.inputContent': '请输入',
  'search.exportFileName': '搜索词',

  // Push related
  'push.title': '标题',
  'push.titleEn': '英文标题',
  'push.content': '内容',
  'push.contentEn': '英文内容',
  'push.toPage': '跳转页面',
  'push.toUser': '推送用户',
  'push.sendTime': '发送时间',
  'push.toPage1': '单部剧详情',
  'push.toPage2': 'rewards页面',
  'push.toPage3': 'most trending',
  'push.toPage4': '剧集列表',
  'push.toUser1': '全站',
  'push.toUser2': '有资格的用户',
  'push.toUser3': '周/月/年订阅用户',
  'push.toUser4': '有金币消费历史用户',
  'push.exportFileName': '平台推送',

  // Sensitive words related
  'words.contents': '敏感词',
  'words.inputContents': '请输入敏感词',
  'words.contentsLength': '敏感词长度在1到100个字符之间',
  'words.exportFileName': '敏感词',
  'words.importTitle': '敏感词导入',
  'words.uploading': '上传中...',
  'words.importDragText': '请将文件拖拽到此处上传❥(^_-)',
  'words.importHint': '支持单个上传，也可以点击后选择文件上传',
  'words.downloadTemplate': '下载模板',
  'words.importTemplateFileName': 'sensitive-words',

  // Video tag related
  'videoTag.tagTitleIn': '标题名称(中文)',
  'videoTag.tagTitleEn': '标题名称(英文)',
  'videoTag.tagTitleCn': '标题名称(法语)',
  'videoTag.tagTitle': '标题名称(阿拉伯)',
  'videoTag.sort': '排序(正序)',
  'videoTag.isOpen': '是否启用',
  'videoTag.inputTagTitleIn': '请输入标题名称(中文)',
  'videoTag.inputTagTitleEn': '请输入标题名称(英文)',
  'videoTag.inputTagTitleCn': '请输入标题名称(法语)',
  'videoTag.inputTagTitle': '请输入标题名称(阿拉伯)',
  'videoTag.inputSort': '请输入排序',
  'videoTag.tagTitleInRequired': '标题名称(中文)不能为空',
  'videoTag.tagTitleEnRequired': '标题名称(英文)不能为空',
  'videoTag.tagTitleCnRequired': '标题名称(法语)不能为空',
  'videoTag.tagTitleRequired': '标题名称(阿拉伯)不能为空',
  'videoTag.tagTitleBmRequired': '标题名称(西班牙语)不能为空',
  'videoTag.inputTagTitleBm': '请输入标题名称(西班牙语)',
  'videoTag.inputTagTitleInRequired': '请输入标题名称(日语)',
  'videoTag.sortLabel': '排序',
  'videoTag.createTime': '创建时间',
  'videoTag.operationSuccess': '操作成功',
  'videoTag.selectColor': '请选择颜色',
  'videoTag.uploadBackground': '请上传背景图',
  'videoTag.uploadFailed': '上传失败，请重试',
  'videoTag.uploadImage': '请上传图片',
  'videoTag.exportFileName': '短剧标签',

  // Gather related
  'gather.videoName': '短剧名称',
  'gather.video': '视频',
  'gather.serialNumber': '当前集数',
  'gather.subtitle': '字幕(阿拉伯)',
  'gather.subtitleEn': '字幕(英文)',
  'gather.subtitleCn': '字幕(法语)',
  'gather.subtitleIn': '字幕',
  'gather.inputVideoName': '请选择短剧',
  'gather.inputSerialNumber': '请输入当前集数',
  'gather.upload': '上传',
  'gather.replace': '更换',
  'gather.preview': '预览',
  'gather.uploadVideo': '请上传视频',
  'gather.uploadVttFile': '请上传vtt或srt文件',
  'gather.invalidFileType': '文件类型不正确',
  'gather.waitUploadComplete': '请等待上一个上传完成后重试',
  'gather.videoUrlRequired': '视频不能为空',
  'gather.videoIdRequired': '短剧名称不能为空',
  'gather.serialNumberRequired': '当前集数不能为空',
  'gather.episode': '第{num}集',
  'gather.updateTime': '更新时间',
  'gather.unknownSubtitleType': '未知的字幕类型',
  'gather.cosCredentialFailed': '获取COS凭证失败',
  'gather.uploadSuccess': '上传成功',
  'gather.saveFailed': '保存失败',
  'gather.uploadFailed': '上传失败，请重试',
  'gather.exportFileName': '剧集',

  // Route related
  'route.home': '首页',
  'route.accountCenter': '个人中心',
  'route.accountSettings': '个人设置',
  'route.smsSettings': '短信设置',
  'route.jobLog': '调度日志',
  'route.authUser': '分配用户',
  'route.noticeEdit': '公告编辑',
  'route.genEdit': '修改生成配置',

  // Guide related
  'guide.page': '指南页面',
  'guide.title': '标题',
  'guide.content': '内容',
  'guide.image': '图片',
  'guide.sort': '排序',
  'guide.status': '状态',
  'guide.createTime': '创建时间',
  'guide.guidePage': '引导页',
  'guide.selectStatus': '请输入是否禁用',
  'guide.upload': '上传',
  'guide.inputSort': '请输入',
  'guide.sortRequired': '排序不能为空',
  'guide.bannerUrlRequired': '引导页url不能为空',
  'guide.uploadImage': '请上传图片',
  'guide.uploadFailed': '上传失败，请重试',
  'guide.add': '添加',
  'guide.edit': '修改',
  'guide.exportFileName': '引导页',
  'guide.operationSuccess': '操作成功',

  // Dashboard statistics related
  'dashboard.totalUserCount': '总用户数',
  'dashboard.totalVipCount': '会员用户总数',
  'dashboard.totalRechargeAmount': '充值总金额',
  'dashboard.today': '今日',
  'dashboard.yesterday': '昨日',
  'dashboard.last7Days': '近七日',
  'dashboard.newUserCount': '新增用户数',
  'dashboard.newSubUserCount': '新增下级用户数',
  'dashboard.rechargeCoinIncome': '累计充值金币收入',
  'dashboard.commissionIncome': '累计佣金收入',
  'dashboard.vipIncome': '累计购买会员收入',
  'dashboard.episodeIncome': '累计购买剧集收入',
  'dashboard.rechargeOrderCount': '下级用户充值订单数',
  'dashboard.rechargeAmount': '下级用户充值金额',
  'dashboard.coinCount': '金币数',
  'dashboard.order': '单',
  'dashboard.userRechargeOverview': '用户充值概览',
  'dashboard.rechargeIncome': '充值收入',
  'dashboard.rechargeOrderNum': '充值订单数',
  'dashboard.subUserRechargeOverview': '下级用户充值概览',
  'dashboard.commissionIncomeOverview': '佣金收入概览',
  'dashboard.vipSubscriptionOverview': '会员订阅概览',
  'dashboard.subscriptionIncome': '订阅收入',
  'dashboard.subscriptionCount': '订阅数',
  'dashboard.dataValue': '数据值',
  'dashboard.rechargeCount': '充值数',
  'dashboard.peopleCount': '人数',
  'dashboard.totalCoinIncome': '累计金币收入',
  'dashboard.totalVipRechargeIncome': '累计会员充值收入',
  'dashboard.totalEpisodePurchaseIncome': '累计剧集购买收入',
  'dashboard.paypay': 'PayPal',
  'dashboard.iosPurchase': 'IOS内购',

  // Buy video related
  'buyVideo.nickname': '昵称',
  'buyVideo.serialNumber': '剧集',
  'buyVideo.videoName': '短剧名称',
  'buyVideo.orderNo': '订单号',
  'buyVideo.type': '购买类型',
  'buyVideo.price': '花费金额',
  'buyVideo.free': '免费',
  'buyVideo.coin': '金币',
  'buyVideo.watchAd': '观看广告',
  'buyVideo.detail': '详情',
  'buyVideo.inputNickname': '请输入昵称',
  'buyVideo.inputSerialNumber': '请输入',
  'buyVideo.selectVideo': '请选择短剧',
  'buyVideo.userId': '用户id',
  'buyVideo.videoId': '短剧id',
  'buyVideo.gatherId': '剧集id',
  'buyVideo.typeLabel': '类型 0-免费 1-金币 2-金币',
  'buyVideo.remark': '备注',
  'buyVideo.inputUserId': '请输入用户id',
  'buyVideo.inputVideoId': '请输入短剧id',
  'buyVideo.inputGatherId': '请输入剧集id',
  'buyVideo.inputPrice': '请输入花费金额',
  'buyVideo.inputContent': '请输入内容',
  'buyVideo.userIdRequired': '用户id不能为空',
  'buyVideo.videoIdRequired': '短剧id不能为空',
  'buyVideo.gatherIdRequired': '剧集id不能为空',
  'buyVideo.typeRequired': '类型 0-免费 1-金币 2-金币不能为空',
  'buyVideo.purchaseDetail': '购买详情',
  'buyVideo.purchaseInfo': '购买信息',
  'buyVideo.userNickname': '用户昵称',
  'buyVideo.createTime': '创建时间',
  'buyVideo.close': '关闭',
  'buyVideo.dataNotExist': '数据不存在',

  // Biz user related
  'bizUser.nickname': '昵称',
  'bizUser.email': '邮箱',
  'bizUser.isVip': '是否会员',
  'bizUser.mobile': '手机号',
  'bizUser.userId': '用户ID',
  'bizUser.showId': '显示ID',
  'bizUser.type': '类型',
  'bizUser.phone': '手机号',
  'bizUser.emailType': '邮箱',
  'bizUser.thirdParty': '三方',
  'bizUser.areaCode': '手机区号',
  'bizUser.thirdPartyAccount': '三方账号',
  'bizUser.invitationCode': '邀请码',
  'bizUser.userStatus': '用户状态',
  'bizUser.isVipStatus': '是否会员',
  'bizUser.vipType': '类型',
  'bizUser.weekVip': '周会员',
  'bizUser.monthVip': '月会员',
  'bizUser.yearVip': '年会员',
  'bizUser.vipExpireTime': '会员过期时间',
  'bizUser.coinCount': '金币数',
  'bizUser.registerTime': '注册时间',
  'bizUser.rechargeCoin': '充值金币',
  'bizUser.inputNickname': '请输入昵称',
  'bizUser.inputEmail': '请输入邮箱',
  'bizUser.selectIsVip': '请选择是否会员',
  'bizUser.inputMobile': '请输入手机号',
  'bizUser.yes': '是',
  'bizUser.no': '否',
  'bizUser.rechargeCoinAmount': '充值金币数',
  'bizUser.inputCoinAmount': '请输入',

  // App version related
  'appVersion.appType': 'APP类型',
  'appVersion.android': '安卓',
  'appVersion.ios': '苹果',
  'appVersion.versionName': '版本号名称',
  'appVersion.versionCode': '版本号',
  'appVersion.packageSize': '更新包大小',
  'appVersion.updateUrlType': '更新地址类型',
  'appVersion.internal': '内部',
  'appVersion.market': '其它(应用市场)',
  'appVersion.updateType': '更新类型',
  'appVersion.hotUpdate': '热更新',
  'appVersion.fullUpdate': '整包更新',
  'appVersion.forceUpdate': '强制升级否',
  'appVersion.forceUpdateStatus': '强制升级状态',
  'appVersion.canSkip': '可跳过',
  'appVersion.force': '强制',
  'appVersion.downloadUrl': '下载地址',
  'appVersion.updateNotes': '更新说明',
  'appVersion.notesZh': '更新说明（中文）',
  'appVersion.notesEn': '更新说明（英语）',
  'appVersion.notesFr': '更新说明（法语）',
  'appVersion.notesAr': '更新说明（阿拉伯语）',
  'appVersion.notesEs': '更新说明（西班牙语）',
  'appVersion.inputVersionName': '请输入版本号名称(15字)',
  'appVersion.inputVersionCode': '请输入版本号',
  'appVersion.inputPackageSize': '请输入更新包大小',
  'appVersion.inputMarketUrl': '请输入其它(应用市场)应用 【内部使用文件库】',
  'appVersion.inputDownloadUrl': '请输入下载地址',
  'appVersion.inputUpdateNotes': '请输入更新说明',
  'appVersion.selectAppType': '请选择',
  'appVersion.selectUpdateUrlType': '请选择',
  'appVersion.selectUpdateType': '请选择',
  'appVersion.selectForceUpdate': '请选择',
  'appVersion.appTypeRequired': 'APP类型不能为空',
  'appVersion.updateUrlTypeRequired': '更新地址类型不能为空',
  'appVersion.versionCodeRequired': '版本号不能为空',
  'appVersion.updateTypeRequired': '更新类型不能为空',
  'appVersion.forceUpdateRequired': '强制升级状态不能为空',
  'appVersion.downloadUrlRequired': '下载地址不能为空',
  'appVersion.uploadApk': '上传APK',
  'appVersion.apkUploading': 'APK上传中，请稍候',
  'appVersion.uploadApkTip': '本地选择APK上传到服务器，完成后自动填入下载地址和包大小(MB)',
  'appVersion.apkUploadFail': 'APK上传失败，未返回下载地址',
  'appVersion.apkOnly': '只能上传 .apk 文件',
  'appVersion.apkUploadSuccess': 'APK上传成功，已填入下载地址',
  'appVersion.apkNoDownloadDomain': '未配置下载域名(tencent.cos.download-url)，COS默认域名禁止下载APK，请配置自定义域名后重新上传',
  'appVersion.confirmDelete': '确认删除所选中数据?',
  'appVersion.confirmDeleteContent': '当前选中编号为',
  'appVersion.selectDataToDelete': '请选择要删除的数据',

  // Feedback related
  'feedback.userNickname': '用户昵称',
  'feedback.contact': '联系方式',
  'feedback.processStatus': '处理状态',
  'feedback.pending': '待处理',
  'feedback.processed': '已处理',
  'feedback.ignored': '暂不处理',
  'feedback.userId': '用户ID',
  'feedback.showId': '显示ID',
  'feedback.content': '反馈内容',
  'feedback.images': '反馈图片',
  'feedback.processResult': '处理结果',
  'feedback.inputUserNickname': '请输入用户昵称',
  'feedback.inputContact': '请输入联系方式',
  'feedback.selectProcessStatus': '请选择处理状态',
  'feedback.inputProcessResult': '请输入处理结果',
  'feedback.processStatusRequired': '处理状态不能为空',
  'feedback.process': '处理',
  'feedback.confirmDelete': '确认删除所选中数据?',
  'feedback.confirmDeleteContent': '当前选中编号为',

  // Cancel related
  'cancel.userNickname': '用户昵称',
  'cancel.cancelReason': '注销原因',
  'cancel.auditStatus': '审核状态',
  'cancel.auditFailReason': '审核失败原因',
  'cancel.auditor': '审核人',
  'cancel.userId': '用户ID',
  'cancel.showId': '显示ID',
  'cancel.pendingAudit': '待审核',
  'cancel.auditSuccess': '审核成功',
  'cancel.auditFailed': '审核失败Hot',
  'cancel.agree': '同意',
  'cancel.reject': '拒绝',
  'cancel.inputNickname': '请输入昵称',
  'cancel.inputCancelReason': '请输入注销原因',
  'cancel.inputAuditFailReason': '请输入审核失败原因',
  'cancel.inputAuditor': '请输入审核人',
  'cancel.selectAuditStatus': '请选择审核状态',
  'cancel.cancelReasonRequired': '注销原因不能为空',
  'cancel.auditStatusRequired': '审核状态不能为空',
  'cancel.audit': '审核',
  'cancel.mobileRequired': '联系电话不能为空',
  'cancel.mobileFormatError': '请正确填写联系电话',
  'cancel.exportFileName': '用户注销',

  // Account center related
  'account.tags': '标签',
  'account.newTag': 'New Tag',
  'account.article': '文章',
  'account.app': '应用',
  'account.project': '项目',
  'account.activeUser': '活跃用户',
  'account.newUser': '新增用户',
  'account.loadMore': '加载更多',
  'account.designLanguage': '设计语言',
  'account.antFinancial': '蚂蚁金服',
  'account.tenThousand': '万',

  // Account settings related
  'accountSettings.baseSettings': '基本设置',
  'accountSettings.securitySettings': '安全设置',
  'accountSettings.nickname': '昵称',
  'accountSettings.mobile': '手机',
  'accountSettings.email': '电子邮件',
  'accountSettings.sex': '性别',
  'accountSettings.male': '男',
  'accountSettings.female': '女',
  'accountSettings.inputNickname': '给自己起个名字',
  'accountSettings.inputMobile': '请填写手机号',
  'accountSettings.inputEmail': '请填写手机号邮箱',
  'accountSettings.nicknameRequired': '请输入昵称',
  'accountSettings.emailRequired': '邮箱不能为空',
  'accountSettings.emailFormatError': '请正确填写邮箱地址',
  'accountSettings.mobileRequired': '手机号不能为空',
  'accountSettings.mobileFormatError': '请正确填写手机号',
  'accountSettings.updateAvatar': '修改头像',
  'accountSettings.selectImage': '选择图片',
  'accountSettings.uploadImageWarning': '请上传图片',
  'accountSettings.uploadSuccess': '上传成功',
  'accountSettings.uploadFailed': '上传失败，请重试',
  'accountSettings.uploadAvatarSuccess': '上传头像成功',
  'accountSettings.accountPassword': '账户密码',
  'accountSettings.currentPasswordStrength': '当前密码强度',
  'accountSettings.strong': '强',
  'accountSettings.oldPassword': '旧密码',
  'accountSettings.newPassword': '新密码',
  'accountSettings.confirmPassword': '确认密码',
  'accountSettings.resetPassword': '重置密码',
  'accountSettings.inputOldPassword': '请输入旧密码',
  'accountSettings.inputNewPassword': '请输入新密码',
  'accountSettings.confirmPasswordPlaceholder': '请确认密码',
  'accountSettings.passwordRequired': '密码不能为空',
  'accountSettings.newPasswordRequired': '请输入新密码',
  'accountSettings.newPasswordFormatError': '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种',
  'accountSettings.confirmPasswordRequired': '请再次输入新密码确认',
  'accountSettings.passwordMismatch': '两次输入的密码不一致',
  'accountSettings.tip': '提示',
  'accountSettings.updateSuccess': '修改成功',
  'accountSettings.saveFailed': '保存失败，请重试',

  // Banner related
  'banner.sort': '排序',
  'banner.type': '类型',
  'banner.bannerType': '轮播图',
  'banner.adType': '广告图',
  'banner.jumpType': '跳转类型',
  'banner.video': '短剧',
  'banner.externalLink': '外部链接',
  'banner.rechargePage': '充值页面',
  'banner.signIn': '签到',
  'banner.status': '状态',
  'banner.bannerImage': '轮播图',
  'banner.bannerImageEn': '轮播图(英文)',
  'banner.bannerImageCn': '轮播图(法语)',
  'banner.bannerImageArabic': '轮播图(阿拉伯)',
  'banner.video': '视频',
  'banner.videoEn': '视频(英文)',
  'banner.videoCn': '视频(法语)',
  'banner.videoArabic': '视频(阿拉伯)',
  'banner.isJump': '是否跳转',
  'banner.externalLinkUrl': '外部链接',
  'banner.selectVideo': '请选择短剧',
  'banner.inputSort': '请输入排序',
  'banner.selectType': '请选择',
  'banner.selectJumpType': '请选择跳转类型',
  'banner.selectIsJump': '请选择是否跳转',
  'banner.inputExternalLink': '请输入外部链接',
  'banner.uploadImage': '上传(请优先上传 750px X 1000px 图片)',
  'banner.upload': '上传',
  'banner.bannerVideoSecond': '轮播图视频播放秒数',
  'banner.bannerDisplaySecond': '轮播图展示秒数',
  'banner.videoStartSecond': '视频从第几秒开始播放',
  'banner.inputDisplaySecond': '请输入展示秒数',
  'banner.inputStartSecond': '请输入开始播放秒数',
  'banner.inputValidSecond': '请输入有效的播放秒数（最小值为0）',
  'banner.inputValidStartSecond': '请输入有效的开始播放秒数（最小值为0）',
  'banner.inputValidDisplaySecond': '请输入有效的展示秒数（最小值为0）',
  'banner.sortRequired': '排序不能为空',
  'banner.isJumpRequired': '是否跳转不能为空',
  'banner.linkUrlRequired': '外部链接不能为空',
  'banner.bannerUrlRequired': '轮播图url不能为空',
  'banner.uploadImageWarning': '请上传图片',
  'banner.uploadFailed': '上传失败，请重试',
  'banner.operationSuccess': '操作成功',
  'banner.confirmDelete': '确认删除所选中数据?',
  'banner.confirmDeleteContent': '当前选中编号为',
  'banner.confirmExport': '是否确认导出?',
  'banner.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'banner.exportFileName': '轮播图',

  // Mobile code related
  'mobileCode.areaCode': '区号',
  'mobileCode.country': '国家名称',
  'mobileCode.countryEn': '国家名称(英文)',
  'mobileCode.countryCn': '国家名称(法语)',
  'mobileCode.countryArabic': '国家名称(阿拉伯)',
  'mobileCode.status': '状态',
  'mobileCode.isCommonly': '是否常用',
  'mobileCode.inputAreaCode': '请输入区号',
  'mobileCode.inputCountry': '请输入国家名称',
  'mobileCode.inputCountryEn': '请输入国家名称(英文)',
  'mobileCode.inputCountryCn': '请输入国家名称(法语)',
  'mobileCode.inputCountryArabic': '请输入国家名称(阿拉伯)',
  'mobileCode.areaCodeExample': '区号(示例：+86)',
  'mobileCode.inputAreaCodeExample': '请输入区号(示例：+86)',
  'mobileCode.areaCodeRequired': '区号(示例：+86)不能为空',
  'mobileCode.countryRequired': '阿拉伯国家名称不能为空',
  'mobileCode.countryEnRequired': '英文国家名称不能为空',
  'mobileCode.countryCnRequired': '法语国家名称不能为空',
  'mobileCode.countryBmRequired': '西班牙国家名称不能为空',
  'mobileCode.countryInRequired': '日语国家名称不能为空',
  'mobileCode.confirmDelete': '确认删除所选中数据?',
  'mobileCode.confirmDeleteContent': '当前选中编号为',
  'mobileCode.confirmExport': '是否确认导出?',
  'mobileCode.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'mobileCode.exportFileName': '手机区号',
  'mobileCode.operationSuccess': '操作成功',

  // Problem related
  'problem.title': '标题',
  'problem.titleEn': '标题(英文)',
  'problem.titleCn': '标题(法语)',
  'problem.titleArabic': '标题(阿拉伯)',
  'problem.content': '内容',
  'problem.contentEn': '内容(英文)',
  'problem.contentCn': '内容(法语)',
  'problem.contentArabic': '内容(阿拉伯)',
  'problem.sort': '排序',
  'problem.status': '状态',
  'problem.createTime': '创建时间',
  'problem.sketch': '问题简述',
  'problem.inputTitle': '请输入标题',
  'problem.inputTitleEn': '请输入标题(英文)',
  'problem.inputTitleCn': '请输入标题(法语)',
  'problem.inputTitleArabic': '请输入标题(阿拉伯)',
  'problem.inputSketch': '请输入问题简述',
  'problem.inputSort': '请输入序号',
  'problem.problemTypeIdRequired': '所属分类不能为空',
  'problem.titleRequired': '标题不能为空',
  'problem.sortRequired': '排序不能为空',
  'problem.confirmDelete': '确认删除所选中数据?',
  'problem.confirmDeleteContent': '当前选中编号为',
  'problem.confirmStatus': '确认',
  'problem.enable': '启用',
  'problem.disable': '停用',
  'problem.statusConfirm': '的类型吗?',
  'problem.open': '开启',
  'problem.close': '关',
  'problem.operationSuccess': '操作成功！',

  // Problem type related
  'problemType.id': '标识',
  'problemType.title': '标题',
  'problemType.remark': '备注',
  'problemType.displaySort': '显示排序',
  'problemType.status': '状态',
  'problemType.createTime': '创建时间',
  'problemType.inputTitle': '请输入标题',
  'problemType.inputContent': '请输入内容',
  'problemType.inputSort': '请输入序号',
  'problemType.isOpen': '是否开启',
  'problemType.normal': '正常',
  'problemType.disable': '停用',
  'problemType.titleRequired': '标题不能为空',
  'problemType.displaySortRequired': '显示排序不能为空',
  'problemType.confirmDelete': '确认删除所选中数据?',
  'problemType.confirmDeleteContent': '当前选中编号为',
  'problemType.confirmExport': '是否确认导出?',
  'problemType.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'problemType.exportFileName': '常见问题分类',
  'problemType.operationSuccess': '操作成功！',

  // Publicize related
  'publicize.videoName': '短剧名称',
  'publicize.publicizeVideo': '宣传视频',
  'publicize.sort': '排序',
  'publicize.remark': '备注',
  'publicize.video': '视频',
  'publicize.inputVideoName': '请输入短剧名称',
  'publicize.selectVideo': '请选择短剧',
  'publicize.inputSort': '请输入排序',
  'publicize.inputContent': '请输入内容',
  'publicize.upload': '上传',
  'publicize.preview': '预览',
  'publicize.uploadVideoWarning': '请上传视频',
  'publicize.videoIdRequired': '短剧id不能为空',
  'publicize.confirmDelete': '确认删除所选中数据?',
  'publicize.confirmDeleteContent': '当前选中编号为',
  'publicize.confirmExport': '是否确认导出?',
  'publicize.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'publicize.exportFileName': '短剧宣传',

  // Recharge order related
  'recharge.nickName': '用户昵称',
  'recharge.mobile': '手机号',
  'recharge.email': '邮箱',
  'recharge.orderNo': '订单号',
  'recharge.payNo': '支付单号',
  'recharge.outTrandNo': '三方订单号',
  'recharge.rechargeDiamond': '充值金币数',
  'recharge.giveDiamond': '赠送金币数',
  'recharge.payMoney': '支付金额($)',
  'recharge.menuId': '价格菜单id',
  'recharge.payTime': '支付时间',
  'recharge.status': '状态',
  'recharge.createTime': '创建时间',
  'recharge.remark': '备注',
  'recharge.userId': '用户id',
  'recharge.inputNickName': '请输入用户昵称',
  'recharge.inputMobile': '请输入手机号',
  'recharge.inputEmail': '请输入邮箱',
  'recharge.inputOrderNo': '请输入订单号',
  'recharge.inputPayNo': '请输入支付单号',
  'recharge.inputOutTrandNo': '请输入三方订单号',
  'recharge.inputRechargeDiamond': '请输入充值金币数',
  'recharge.inputPayMoney': '请输入支付金额',
  'recharge.inputMenuId': '请输入价格菜单id',
  'recharge.inputContent': '请输入内容',
  'recharge.inputUserId': '请输入用户id',
  'recharge.pendingPay': '待支付',
  'recharge.paySuccess': '支付成功',
  'recharge.payFailed': '支付失败',
  'recharge.statusLabel': '状态 0-待支付  1-支付成功 2-支付失败',
  'recharge.userIdRequired': '用户id不能为空',
  'recharge.orderNoRequired': '订单号不能为空',
  'recharge.payMoneyRequired': '支付金额不能为空',
  'recharge.statusRequired': '状态 0-待支付  1-支付成功 2-支付失败不能为空',
  'recharge.confirmDelete': '确认删除所选中数据?',
  'recharge.confirmDeleteContent': '当前选中编号为',
  'recharge.confirmExport': '是否确认导出?',
  'recharge.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'recharge.exportFileName': '金币充值订单',

  // Recharge menu related
  'rechargeMenu.rechargePrice': '充值价格',
  'rechargeMenu.rechargeDiamond': '充值金币',
  'rechargeMenu.giveDiamond': '赠送金币',
  'rechargeMenu.status': '状态',
  'rechargeMenu.inputRechargePrice': '请输入充值价格',
  'rechargeMenu.inputRechargeDiamond': '请输入充值金币',
  'rechargeMenu.inputGiveDiamond': '请输入赠送金币',
  'rechargeMenu.rechargePriceRequired': '充值价格不能为空',
  'rechargeMenu.rechargeDiamondRequired': '充值金币不能为空',
  'rechargeMenu.giveDiamondRequired': '赠送金币不能为空',
  'rechargeMenu.confirmDelete': '确认删除所选中数据?',
  'rechargeMenu.confirmDeleteContent': '当前选中编号为',
  'rechargeMenu.confirmExport': '是否确认导出?',
  'rechargeMenu.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'rechargeMenu.exportFileName': '充值菜单',
  'rechargeMenu.operationSuccess': '操作成功',

  // Report forms related
  'reportForms.dateSelect': '日期选择',
  'reportForms.today': '今日',
  'reportForms.yesterday': '昨天',
  'reportForms.last7Days': '近7天',
  'reportForms.last30Days': '近30天',
  'reportForms.totalUser': '用户总数',
  'reportForms.totalPay': '消费人数',
  'reportForms.noTotalPay': '未消费人数',
  'reportForms.vipTotal': '订阅总数',
  'reportForms.activeNum': '活跃总数',
  'reportForms.silentNum': '沉默总数',
  'reportForms.rechargeTrend': '充值趋势',
  'reportForms.iosRechargeTrend': 'ios充值趋势',
  'reportForms.paypalRechargeTrend': 'paypal充值趋势',
  'reportForms.subscriptionTrend': '订阅趋势',
  'reportForms.iosVipRechargeTrend': 'ios充值会员趋势',
  'reportForms.paypalVipRechargeTrend': 'paypal充值会员趋势',
  'reportForms.shopifyVipRechargeTrend': 'shopify充值会员趋势',
  'reportForms.payTypeStatistics': '充值方式统计',
  'reportForms.payTypeTotalMoney': '充值方式累计金额',
  'reportForms.rechargeAreaRanking': '充值区域排行',
  'reportForms.subscriptionAreaRanking': '订阅地域排行',
  'reportForms.dataValue': '数据值',
  'reportForms.source': '来源',
  'reportForms.selectSource': '请选择来源',
  'reportForms.isVip': '是否会员',
  'reportForms.selectIsVip': '请选择是否会员',
  'reportForms.showId': '显示ID',
  'reportForms.inputShowId': '请输入显示ID',
  'reportForms.nickname': '昵称',
  'reportForms.inputNickname': '请输入昵称',
  'reportForms.collapse': '收起',
  'reportForms.expand': '展开',
  'reportForms.userId': '用户ID',
  'reportForms.areaCode': '手机区号',
  'reportForms.address': '地区',
  'reportForms.type': '类型',
  'reportForms.weekVip': '周会员',
  'reportForms.monthVip': '月会员',
  'reportForms.yearVip': '年会员',
  'reportForms.vipExpireTime': '订阅到期时间',
  'reportForms.totalRecharge': '累计充值',
  'reportForms.diamondBalance': '金币余额',
  'reportForms.activity': '活跃度',
  'reportForms.active': '活跃',
  'reportForms.silent': '沉默',
  'reportForms.setVipExpireTime': '设置会员到期时间',
  'reportForms.videoName': '剧名',
  'reportForms.inputVideoName': '请输入剧名',
  'reportForms.cover': '封面',
  'reportForms.episodeCount': '集数',
  'reportForms.playCount': '播放次数',
  'reportForms.collectTotal': '收藏总数',
  'reportForms.totalIncome': '总收益',
  'reportForms.completionRate': '完播率',
  'reportForms.detail': '详情',
  'reportForms.vipExpireTimeLabel': '会员到期时间',
  'reportForms.edit': '修改',
  'reportForms.close': '关闭',
  'reportForms.updateFailed': '更新失败，请重试',
  'reportForms.detailNotImplemented': '详情功能待实现',
  'reportForms.userInfoExportFileName': '用户信息',
  'reportForms.videoReportExportFileName': '视频报表',
  'reportForms.confirmDelete': '确认删除所选中数据?',
  'reportForms.confirmDeleteContent': '当前选中编号为',
  'reportForms.confirmExport': '是否确认导出?',
  'reportForms.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'reportForms.operationSuccess': '操作成功',
  'reportForms.deleteSuccess': '删除成功',
  'reportForms.email': '邮箱',
  'reportForms.mobile': '手机号',
  'reportForms.emailSource': '邮箱',
  'reportForms.mobileSource': '手机',
  'reportForms.thirdPartyLogin': '三方登录',

  // Reward related
  'reward.inviteNum': '邀请人数',
  'reward.rewardNum': '奖励数量',
  'reward.rewardType': '奖励类型',
  'reward.rewardValue': '奖励值(会员：天、金币：个)',
  'reward.giveDiamond': '赠送金币',
  'reward.giveVip': '赠送会员',
  'reward.inputInviteNum': '请输入邀请人数',
  'reward.inputRewardNum': '请输入奖励数量',
  'reward.selectRewardType': '请选择奖励类型',
  'reward.inviteNumRequired': '请输入邀请人数',
  'reward.inviteNumMin': '邀请人数必须大于0',
  'reward.confirmDelete': '确认删除所选中数据?',
  'reward.confirmDeleteContent': '当前选中编号为',
  'reward.confirmExport': '是否确认导出?',
  'reward.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'reward.exportFileName': '邀请用户奖励配置',

  // Sign config related
  'signConfig.days': '天数',
  'signConfig.goldNum': '赠送金币数',
  'signConfig.createTime': '创建时间',
  'signConfig.inputDays': '请输入天数',
  'signConfig.inputGoldNum': '请输入赠送金币数',
  'signConfig.daysRequired': '天数不能为空',
  'signConfig.goldNumRequired': '赠送金币数不能为空',
  'signConfig.confirmDelete': '确认删除所选中数据?',
  'signConfig.confirmDeleteContent': '当前选中编号为',
  'signConfig.confirmExport': '是否确认导出?',
  'signConfig.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'signConfig.exportFileName': '签到配置',

  // System related - common
  'system.userName': '用户名称',
  'system.phoneNumber': '手机号',
  'system.email': '邮箱',
  'system.password': '密码',
  'system.addUser': '新增用户',
  'system.editUser': '修改用户',
  'system.userNameRequired': '用户名不能为空',
  'system.nickNameRequired': '用户昵称不能为空',
  'system.deptRequired': '部门不能为空',
  'system.passwordRequired': '密码不能为空',
  'system.passwordLength': '用户密码长度必须介于 5 和 20 之间',
  'system.status': '状态',
  'system.createTime': '创建时间',
  'system.roleName': '角色名',
  'system.roleKey': '权限字符',
  'system.menuName': '菜单名称',
  'system.inputPlaceholder': '请输入',
  'system.selectPlaceholder': '请选择',
  'system.selectStatus': '请选择状态',
  'system.collapse': '收起',
  'system.expand': '展开',
  'system.enable': '启用',
  'system.disable': '停用',
  'system.confirmEnable': '确认启用',
  'system.confirmDisable': '确认停用',
  'system.user': '用户',
  'system.role': '角色',
  'system.on': '开',
  'system.off': '关',
  'system.yes': '是',
  'system.no': '否',
  'system.resetPassword': '重置密码',
  'system.newPassword': '新密码',
  'system.confirmPassword': '确认密码',
  'system.inputNewPassword': '请输入新密码',
  'system.inputConfirmPassword': '请确认密码',
  'system.newPasswordRequired': '请输入新密码',
  'system.passwordFormatError': '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种',
  'system.confirmPasswordRequired': '请再次输入新密码确认',
  'system.passwordMismatch': '两次输入的密码不一致',
  'system.assignRole': '分配角色',
  'system.roleSort': '排序',
  'system.menuPermission': '菜单权限',
  'system.expandCollapse': '展开/折叠',
  'system.selectAllDeselectAll': '全选/全不选',
  'system.parentChildLink': '父子联动',
  'system.parentChildLinkTip': '当勾选项为空时方可切换模式，可以点击"全不选"后再次切换。',
  'system.roleKeyTip': '控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole(\'admin\')`)',
  'system.adminRoleInfo': '超级管理员角色信息 不可更改',
  'system.addRole': '添加角色',
  'system.editRole': '修改角色',
  'system.roleNameRequired': '角色名称不能为空',
  'system.roleKeyRequired': '权限字符不能为空',
  'system.roleSortRequired': '显示顺序不能为空',
  'system.dataScope': '数据权限',
  'system.maskScope': '脱敏权限',
  'system.import': '导入',
  'system.export': '导出',
  'system.confirmDelete': '确认删除所选中数据?',
  'system.confirmDeleteContent': '当前选中编号为',
  'system.confirmExport': '是否确认导出?',
  'system.confirmExportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'system.operationSuccess': '操作成功',
  'system.deleteSuccess': '删除成功',
  'system.exportSuccess': '导出成功',
  'system.importSuccess': '导入成功',
  'system.assignRoleSuccess': '分配角色成功',
  'system.dataScopeSuccess': '数据权限设置成功',
  'system.maskScopeSuccess': '脱敏权限设置成功',
  'system.userId': '用户编号',
  'system.inputUserId': '请输入用户id',
  'system.remark': '备注',
  'system.nickName': '用户昵称',
  'system.more': '更多',
  'system.roleId': '角色编号',
  'system.assignUser': '分配用户',
  'system.icon': '图标',
  'system.perms': '权限标识',
  'system.component': '组件路径',
  'system.mainDirectory': '主目录',
  'system.noticeId': '公告编号',
  'system.noticeTitle': '公告标题',
  'system.noticeType': '公告类型',
  'system.createBy': '创建者',
  'system.addNotice': '添加公告',
  'system.editNotice': '修改公告',
  'system.title': '标题',
  'system.titleEn': '标题(英文)',
  'system.titleCn': '标题(法语)',
  'system.titleArabic': '标题(阿拉伯)',
  'system.content': '内容',
  'system.contentEn': '内容(英文)',
  'system.contentCn': '内容(法语)',
  'system.contentArabic': '内容(阿拉伯)',
  'system.inputTitle': '请输入标题',
  'system.inputTitleEn': '请输入标题(英文)',
  'system.inputTitleCn': '请输入标题(法语)',
  'system.inputTitleArabic': '请输入标题(阿拉伯)',
  'system.inputContent': '请输入内容',
  'system.inputContentEn': '请输入内容(英文)',
  'system.inputContentCn': '请输入内容(法语)',
  'system.inputContentArabic': '请输入内容(阿拉伯)',
  'system.titleRequired': '标题不能为空',
  'system.titleEnRequired': '标题(英文)不能为空',
  'system.titleCnRequired': '标题(法语)不能为空',
  'system.titleArabicRequired': '标题(阿拉伯)不能为空',
  'system.contentRequired': '内容不能为空',
  'system.contentEnRequired': '内容(英文)不能为空',
  'system.contentCnRequired': '内容(法语)不能为空',
  'system.contentArabicRequired': '内容(阿拉伯)不能为空',
  'system.normal': '正常',
  'system.configName': '参数名称',
  'system.configKey': '参数键名',
  'system.configGroup': '参数分组',
  'system.configType': '参数类型',
  'system.configValue': '参数键值',
  'system.configValueEn': '参数键值(英文)',
  'system.configValueCn': '参数键值(法语)',
  'system.configValueArabic': '参数键值(阿拉伯)',
  'system.configTypeInput': '输入框',
  'system.configTypeTextarea': '文本框',
  'system.configTypeRichText': '富文本',
  'system.configTypeImage': '图片',
  'system.addConfig': '添加参数',
  'system.editConfig': '修改参数',
  'system.configNameRequired': '参数名称不能为空',
  'system.configGroupRequired': '参数分组不能为空',
  'system.configKeyRequired': '参数键名不能为空',
  'system.configValueRequired': '参数键值不能为空',
  'system.configSystem': '系统内置',
  'system.dictName': '字典名称',
  'system.dictType': '字典类型',
  'system.dictId': '字典编号',
  'system.inputDictName': '请输入字典名称',
  'system.inputDictType': '请输入字典类型',
  'system.dictStatus': '字典状态',
  'system.deptName': '部门名称',
  'system.refreshCache': '刷新缓存',
  'system.refreshSuccess': '刷新成功',

  // Dict labels (backend dictLabel is Chinese)
  'dict.sysCommonStatus.success': '成功',
  'dict.sysCommonStatus.fail': '失败',
  'dict.sysOperType.other': '其他',
  'dict.sysOperType.insert': '新增',
  'dict.sysOperType.update': '修改',
  'dict.sysOperType.delete': '删除',
  'dict.sysOperType.grant': '授权',
  'dict.sysOperType.export': '导出',
  'dict.sysOperType.import': '导入',
  'dict.sysOperType.forceLogout': '强退',
  'dict.sysOperType.genCode': '生成代码',
  'dict.sysOperType.clean': '清空数据',

  // Monitor - operlog
  'monitor.operlog.systemModule': '系统模块',
  'monitor.operlog.inputSystemModule': '请输入系统模块',
  'monitor.operlog.operName': '操作人员',
  'monitor.operlog.inputOperName': '请输入操作人员',
  'monitor.operlog.filterType': '类型',
  'monitor.operlog.businessTypePlaceholder': '操作类型',
  'monitor.operlog.statusPlaceholder': '操作状态',
  'monitor.operlog.operTime': '操作时间',
  'monitor.operlog.operId': '日志编号',
  'monitor.operlog.businessType': '操作类型',
  'monitor.operlog.requestMethod': '请求方式',
  'monitor.operlog.host': '主机',
  'monitor.operlog.operLocation': '操作地点',
  'monitor.operlog.operStatus': '操作状态',
  'monitor.operlog.operDate': '操作日期',
  'monitor.operlog.detail': '详细',
  'monitor.operlog.clean': '清空',
  'monitor.operlog.confirmDeleteContent': '当前选中日志编号为 {ids} 的数据',
  'monitor.operlog.confirmClean': '是否确认清空?',
  'monitor.operlog.confirmCleanContent': '此操作将会清空所有操作日志数据项',
  'monitor.operlog.cleanSuccess': '清空成功',
  'monitor.operlog.viewOperInfo': '操作信息',
  'monitor.operlog.operModule': '操作模块',
  'monitor.operlog.loginInfo': '登录信息',
  'monitor.operlog.requestUrl': '请求地址',
  'monitor.operlog.operMethod': '操作方法',
  'monitor.operlog.apiInfo': '接口信息',
  'monitor.operlog.requestParam': '请求参数',
  'monitor.operlog.responseParam': '返回参数',
  'monitor.operlog.errorMsg': '异常信息',
  'monitor.operlog.statusNormal': '正常',
  'monitor.operlog.statusFail': '失败',
  'monitor.operlog.titleDailyActivity': '日活统计',
  'monitor.operlog.titleConfig': '参数管理',
  'monitor.operlog.titleNotice': '通知公告',
  'monitor.operlog.titleVideoAdd': '新增短剧',
  'monitor.operlog.titleVideoEdit': '编辑短剧',
  'monitor.operlog.titleVideoDelete': '删除短剧',
  'monitor.operlog.titleVideoExport': '导出短剧',
  'monitor.operlog.titleVideoImport': '视频导入',
  'monitor.operlog.titleUserExport': '导出用户列表',
  'monitor.operlog.titleToggleStatus': '编辑是否开启',
  'monitor.operlog.titleVideoSort': '编辑短剧排序',
  'monitor.operlog.titleHelpAdd': '新增帮助中心',
  'monitor.operlog.titleHelpEdit': '编辑帮助中心',
  'monitor.operlog.titleHelpDelete': '删除帮助中心',
  'monitor.operlog.titleMobileCodeAdd': '新增手机区号',
  'monitor.operlog.titleMobileCodeEdit': '编辑手机区号',
  'monitor.operlog.titleMobileCodeDelete': '删除手机区号',
  'monitor.operlog.titleMobileCodeExport': '导出手机区号',
  'monitor.operlog.titleGuideAdd': '新增引导页',
  'monitor.operlog.titleGuideEdit': '编辑引导页',
  'monitor.operlog.titleGuideDelete': '删除引导页',
  'monitor.operlog.titleGuideExport': '导出引导页',
  'monitor.operlog.titleAvatarAdd': '新增用户头像',
  'monitor.operlog.titleAvatarEdit': '编辑用户头像',
  'monitor.operlog.titleAvatarDelete': '删除用户头像',
  'monitor.operlog.titleAvatarExport': '导出用户头像',
  'monitor.operlog.titleWordsAdd': '新增敏感词',
  'monitor.operlog.titleWordsEdit': '编辑敏感词',
  'monitor.operlog.titleWordsDelete': '删除敏感词',
  'monitor.operlog.titleWordsExport': '导出敏感词',
  'monitor.operlog.titleAdAdd': '新增广告',
  'monitor.operlog.titleAdEdit': '编辑广告',
  'monitor.operlog.titleAdDelete': '删除广告',
  'monitor.operlog.titleAdExport': '导出广告',
  'monitor.operlog.titleVipOrder': '会员下单',
  'monitor.operlog.titleVipBind': '会员绑定用户',
  'monitor.operlog.titleRechargeOrder': '充值下单',
  'monitor.operlog.titleRechargeAdd': '新增钻石充值订单',
  'monitor.operlog.titleRechargeEdit': '编辑钻石充值订单',
  'monitor.operlog.titleRechargeDelete': '删除钻石充值订单',
  'monitor.operlog.titleInviteRewardAdd': '新增邀请用户奖励配置',
  'monitor.operlog.titleInviteRewardEdit': '编辑邀请用户奖励配置',
  'monitor.operlog.titleProblemAdd': '新增常见问题',
  'monitor.operlog.titleProblemEdit': '编辑常见问题',
  'monitor.operlog.titleProblemStatus': '编辑常见问题状态',
  'monitor.operlog.titleProblemDelete': '删除常见问题',
  'monitor.operlog.titleProblemExport': '导出常见问题',
  'monitor.operlog.titlePerformerAdd': '新增视频演员',
  'monitor.operlog.titlePerformerEdit': '编辑视频演员',
  'monitor.operlog.titlePerformerDelete': '删除视频演员',
  'monitor.operlog.titleUserDailyActivity': '用户日活统计',

  // Monitor - logininfor
  'monitor.logininfor.loginAddress': '登录地址',
  'monitor.logininfor.inputLoginAddress': '请输入登录地址',
  'monitor.logininfor.useStatus': '使用状态',
  'monitor.logininfor.loginName': '登录名称',
  'monitor.logininfor.inputLoginName': '请输入登录名称',
  'monitor.logininfor.loginTime': '登录时间',
  'monitor.logininfor.infoId': '访问编号',
  'monitor.logininfor.userName': '用户名称',
  'monitor.logininfor.loginLocation': '登录地点',
  'monitor.logininfor.unknownLocation': '未知地址',
  'monitor.logininfor.browser': '浏览器',
  'monitor.logininfor.os': '操作系统',
  'monitor.logininfor.operMsg': '操作信息',
  'monitor.logininfor.unlock': '解锁',
  'monitor.logininfor.confirmDeleteContent': '当前选中访问编号为 {ids} 的数据',
  'monitor.logininfor.confirmClean': '是否确认清空?',
  'monitor.logininfor.confirmCleanContent': '此操作将会清空所有登录日志数据项',
  'monitor.logininfor.confirmUnlock': '是否确认解锁用户: {username}?',
  'monitor.logininfor.unlockSuccess': '解锁成功',

  // Monitor - server
  'monitor.server.cpu': 'CPU',
  'monitor.server.memory': '内存',
  'monitor.server.cpuNum': '核心数',
  'monitor.server.cpuUsed': '用户使用率',
  'monitor.server.cpuSys': '系统使用率',
  'monitor.server.cpuFree': '当前空闲率',
  'monitor.server.serverInfo': '服务器信息',
  'monitor.server.computerName': '服务器名称',
  'monitor.server.osName': '操作系统',
  'monitor.server.computerIp': '服务器IP',
  'monitor.server.osArch': '系统架构',
  'monitor.server.jvmInfo': 'Java虚拟机信息',
  'monitor.server.javaName': 'Java名称',
  'monitor.server.javaVersion': 'Java版本',
  'monitor.server.startTime': '启动时间',
  'monitor.server.runTime': '运行时长',
  'monitor.server.installPath': '安装路径',
  'monitor.server.projectPath': '项目路径',
  'monitor.server.runArgs': '运行参数',
  'monitor.server.diskStatus': '磁盘状态',
  'monitor.server.attr': '属性',
  'monitor.server.memColumn': '内存',
  'monitor.server.dirPath': '盘符路径',
  'monitor.server.fileSystem': '文件系统',
  'monitor.server.diskType': '盘符类型',
  'monitor.server.totalSize': '总大小',
  'monitor.server.freeSize': '可用大小',
  'monitor.server.usedSize': '已用大小',
  'monitor.server.usagePercent': '已用百分比',
  'monitor.server.mem.total': '总内存',
  'monitor.server.mem.used': '已用内存',
  'monitor.server.mem.free': '剩余内存',
  'monitor.server.mem.usage': '使用率',

  // Monitor - cache
  'monitor.cache.basicInfo': '基本信息',
  'monitor.cache.redisVersion': 'Redis版本',
  'monitor.cache.runMode': '运行模式',
  'monitor.cache.standalone': '单机',
  'monitor.cache.cluster': '集群',
  'monitor.cache.port': '端口',
  'monitor.cache.clients': '客户端数',
  'monitor.cache.uptimeDays': '运行时间(天)',
  'monitor.cache.usedMemory': '使用内存',
  'monitor.cache.usedCpu': '使用CPU',
  'monitor.cache.memoryConfig': '内存配置',
  'monitor.cache.aofEnabled': 'AOF是否开启',
  'monitor.cache.rdbStatus': 'RDB是否成功',
  'monitor.cache.keyCount': 'Key数量',
  'monitor.cache.networkKps': '网络入口/出口',
  'monitor.cache.commandStats': '命令统计',
  'monitor.cache.memoryInfo': '内存信息',
  'monitor.cache.chartCommand': '命令',
  'monitor.cache.chartPeak': '峰值',
  'monitor.cache.chartMemoryConsumption': '内存消耗',

  // Monitor - cache list
  'monitor.cacheList.cacheList': '缓存列表',
  'monitor.cacheList.keyList': '键名列表',
  'monitor.cacheList.cacheContent': '缓存内容',
  'monitor.cacheList.cacheName': '缓存名称',
  'monitor.cacheList.cacheKey': '缓存键名',
  'monitor.cacheList.cacheValue': '缓存内容',
  'monitor.cacheList.confirmClearAll': '确认清除全部缓存吗?',
  'monitor.cacheList.confirmDelete': '确认删除缓存: {name} 吗?',
  'monitor.cacheList.refreshNamesSuccess': '刷新缓存列表成功',
  'monitor.cacheList.clearNameSuccess': '清理缓存名称[{name}]成功',
  'monitor.cacheList.refreshKeysSuccess': '刷新键名列表成功',
  'monitor.cacheList.clearKeySuccess': '清理缓存键名[{key}]成功',
  'monitor.cacheList.clearAllSuccess': '清理全部缓存成功',

  // Menu labels for internationalization
  'menu.videoManagement': '短剧管理',
  'menu.videoList': '短剧列表',
  'menu.barrageManagement': '弹幕管理',
  'menu.publicizeManagement': '宣传片管理',
  'menu.sensitiveWordManagement': '敏感词管理',
  'menu.videoCategoryManagement': '短剧分类管理',
  'menu.userBuyVideoList': '用户购买剧集列表',
  'menu.userManagement': '用户管理',
  'menu.userInfo': '用户信息',
  'menu.userWithdraw': '用户提现',
  'menu.userFeedback': '用户反馈',
  'menu.userCancelManagement': '用户注销管理',
  'menu.userReport': '用户报表',
  'menu.userRights': '用户权益',
  'menu.exchangeCode': '兑换码',
  'menu.referralRewardConfig': '拉人奖励配置',
  'menu.vipPurchaseList': '会员购买列表',
  'menu.signConfig': '签到配置',
  'menu.taskRewardManagement': '任务奖励管理',
  'menu.rechargeManagement': '充值管理',
  'menu.rechargeMenuManagement': '充值菜单管理',
  'menu.vipMenuManagement': '会员菜单管理',
  'menu.resourcePositionConfig': '资源位配置',
  'menu.urlManagement': '网址管理',
  'menu.helpCenter': '帮助中心',
  'menu.guidePage': '引导页',
  'menu.distributionConfig': '分销配置',
  'menu.carouselManagement': '轮播图管理',
  'menu.searchWordManagement': '搜索词管理',
  'menu.avatarManagement': '头像管理',
  'menu.tabbarManagement': 'Tabbar管理',
  'menu.mobileCodeManagement': '手机区号管理',
  'menu.financialReport': '财务报表',
  'menu.videoReport': '短剧报表',
  'menu.coinRechargeOrderList': '金币充值订单列表',
  'menu.versionUpdate': '版本更新',
  'menu.versionManagement': '版本管理',
  'menu.systemManagement': '系统管理',
  'menu.userQuery': '用户查询',
  'menu.userAdd': '用户新增',
  'menu.userEdit': '用户修改',
  'menu.userDelete': '用户删除',
  'menu.userExport': '用户导出',
  'menu.userImport': '用户导入',
  'menu.resetPassword': '重置密码',
  'menu.roleManagement': '角色管理',
  'menu.roleQuery': '角色查询',
  'menu.roleAdd': '角色新增',
  'menu.roleEdit': '角色修改',
  'menu.roleDelete': '角色删除',
  'menu.maskPermission': '脱敏权限',
  'menu.menuManagement': '菜单管理',
  'menu.menuQuery': '菜单查询',
  'menu.menuAdd': '菜单新增',
  'menu.menuEdit': '菜单修改',
  'menu.menuDelete': '菜单删除',
  'menu.paramSettings': '参数设置',
  'menu.paramQuery': '参数查询',
  'menu.paramAdd': '参数新增',
  'menu.paramEdit': '参数修改',
  'menu.paramDelete': '参数删除',
  'menu.paramExport': '参数导出',
  'menu.noticeAnnouncement': '通知公告',
  'menu.noticeQuery': '公告查询',
  'menu.noticeAdd': '公告新增',
  'menu.noticeEdit': '公告修改',
  'menu.noticeDelete': '公告删除',
  'menu.logManagement': '日志管理',
  'menu.operationLog': '操作日志',
  'menu.operationQuery': '操作查询',
  'menu.operationDelete': '操作删除',
  'menu.logExport': '日志导出',
  'menu.loginLog': '登录日志',
  'menu.loginQuery': '登录查询',
  'menu.loginDelete': '登录删除',
  'menu.accountUnlock': '账户解锁',
  'menu.systemTools': '系统工具',
  'menu.formBuilder': '表单构建',
  'menu.codeGeneration': '代码生成',
  'menu.generateQuery': '生成查询',
  'menu.generateEdit': '生成修改',
  'menu.generateDelete': '生成删除',
  'menu.importCode': '导入代码',
  'menu.previewCode': '预览代码',
  'menu.generateCode': '生成代码',
  'menu.systemInterface': '系统接口',
  'menu.databaseDoc': '数据库文档',
  'menu.systemMonitor': '系统监控',
  'menu.dataMonitor': '数据监控',
  'menu.serviceMonitor': '服务监控',
  'menu.cacheMonitor': '缓存监控',
  'menu.cacheList': '缓存列表',

  // User related - login and register
  'user.account': '账户',
  'user.password': '密码',
  'user.confirmPassword': '确认密码',
  'user.captcha': '验证码',
  'user.rememberPassword': '记住密码',
  'user.confirm': '确定',
  'user.register': '注册',
  'user.login': '登录',
  'user.useExistingAccount': '使用已有账户登录',
  'user.loginFailed': '登录失败，请检查账号密码',
  'user.welcome': '欢迎',
  'user.welcomeBack': '欢迎回来',
  'user.registerSuccess': '恭喜你，您的账号 {username} 注册成功！',
  'user.inputAccount': '请输入帐户名',
  'user.inputPassword': '请输入密码',
  'user.inputCaptcha': '请输入验证码',
  'user.inputNewPassword': '请输入新密码',
  'user.inputNewPasswordRule': '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种',
  'user.inputConfirmPassword': '请再次输入新密码确认',
  'user.passwordNotMatch': '两次输入的密码不一致',
  'user.inputAccountName': '请输入您的账号',
  'user.accountLength': '用户账号长度必须介于 2 和 20 之间',
  'user.inputYourPassword': '请输入您的密码',
  'user.inputPasswordAgain': '请再次输入您的密码',

  // User related - disposition
  'user.disposition.title': '标题',
  'user.disposition.isOpen': '是否启用',
  'user.disposition.sort': '排序',
  'user.disposition.inputIsOpen': '请输入是否启用',
  'user.disposition.inputSort': '请输入排序',
  'user.disposition.content': '内容',
  'user.disposition.config': '配置',

  // User related - withdraw
  'user.withdraw.nickname': '用户昵称',
  'user.withdraw.email': '邮箱',
  'user.withdraw.mobile': '手机号',
  'user.withdraw.status': '状态',
  'user.withdraw.statusPending': '未审核',
  'user.withdraw.statusRejected': '审核未通过',
  'user.withdraw.statusApproved': '审核通过未打款',
  'user.withdraw.statusPaid': '已打款',
  'user.withdraw.money': '提现金额',
  'user.withdraw.realMoney': '实际需要转账金额',
  'user.withdraw.serviceCharge': '提现手续费',
  'user.withdraw.type': '提现方式',
  'user.withdraw.typePaypal': 'Paypal',
  'user.withdraw.typeBank': '银行卡',
  'user.withdraw.typeAlipay': 'Alipay',
  'user.withdraw.auditOpinion': '审核意见',
  'user.withdraw.applyTime': '申请时间',
  'user.withdraw.audit': '审核',
  'user.withdraw.exportFileName': '用户提现记录',
  'user.withdraw.none': '无',
  'common.more' :'更多',

  // User related - userAvatar
  'user.userAvatar.avatarLink': '头像链接',
  'user.userAvatar.exportFileName': '用户头像',

  // User related - distribution
  'user.distribution.type': '类型',
  'user.distribution.typeRatio': '赠送比例',
  'user.distribution.typeAmount': '赠送数量',
  'user.distribution.description': '描述',
  'user.distribution.amount': '数量',
  'user.distribution.exportFileName': '分销配置',
  'user.distribution.inputDescription': '请输入描述',
  'user.distribution.inputAmount': '请输入赠送',
  'user.distribution.value': '数值',

  // User related - withdraw
  'user.withdraw.realMoney': '实际需要转账金额',
  'user.withdraw.withdrawType': '提现方式',
  'user.withdraw.paypal': 'Paypal',
  'user.withdraw.bankCard': '银行卡',
  'user.withdraw.alipay': 'Alipay',
  'user.withdraw.securityCode': '安全码',
  'user.withdraw.cardNumber': '卡号',
  'user.withdraw.cardholderName': '持卡人姓名',
  'user.withdraw.bankName': '银行名称',
  'user.withdraw.bankCardNumber': '银行卡号',
  'user.withdraw.bankAccount': '开户行',
  'user.withdraw.alipayQRCode': '支付宝收款码',
  'user.withdraw.noQRCode': '暂无收款码',
  'user.withdraw.realName': '真实姓名',
  'user.withdraw.auditOpinion': '审核意见',
  'user.withdraw.inputAuditOpinion': '请输入审核意见',
  'user.withdraw.rejected': '未通过',
  'user.withdraw.approved': '通过',
  'user.withdraw.paid': '打款',

  // User related - koc
  'user.koc.code': '兑换码',
  'user.koc.userNickname': '用户昵称',
  'user.koc.useTime': '使用时间',
  'user.koc.inputCode': '请输入兑换码',
  'user.koc.type': '类型',
  'user.koc.goldCard': '金币卡',
  'user.koc.vipCard': '会员卡',
  'user.koc.typeGold': '金币卡',
  'user.koc.typeVip': '会员卡',
  'user.koc.goldAmount': '金币数量',
  'user.koc.vipDays': '会员天数',
  'user.koc.goldAmountOrVipDays': '金币数量/会员天数',
  'user.koc.numberValue': '金币数量/会员天数',
  'user.koc.useStatus': '使用状态',
  'user.koc.isUsed': '已使用',
  'user.koc.statusUsed': '已使用',
  'user.koc.statusUnused': '未使用',
  'user.koc.addAmount': '添加数量',
  'user.koc.userIdRequired': '用户id不能为空',

  // User related - userAvatar
  'user.userAvatar.avatarLinkRequired': '头像链接不能为空',
  'user.userAvatar.operationSuccess': '操作成功！',

  // User related - disposition
  'user.disposition.inputContent': '请输入内容',
  'user.disposition.arabicContentRequired': '阿拉伯内容不能为空',
  'user.disposition.isOpenRequired': '是否启用不能为空',

  // User related - withdraw
  'user.withdraw.audit': '审核',
  'user.withdraw.userIdRequired': '用户id，外键不能为空',
  'user.withdraw.moneyRequired': '提现金额不能为空',
  'user.withdraw.statusRequired': '状态不能为空',
  'user.withdraw.withdrawTypeRequired': '提现方式不能为空',
  'user.withdraw.withdrawUserTypeRequired': '提现类型不能为空',

  // VIP related - menu
  'vip.menu.unitPrice': '每天单价',
  'vip.menu.inputUnitPrice': '请输入每天单价',
  'vip.menu.totalPrice': '总价',
  'vip.menu.inputTotalPrice': '请输入总价',
  'vip.menu.remark': '备注',
  'vip.menu.inputRemark': '请输入备注',
  'vip.menu.remarkEn': '备注(英文)',
  'vip.menu.inputRemarkEn': '请输入备注(英文)',
  'vip.menu.remarkCn': '备注(法语)',
  'vip.menu.inputRemarkCn': '请输入备注(法语)',
  'vip.menu.remarkArabic': '备注(阿拉伯)',
  'vip.menu.inputRemarkArabic': '请输入备注(阿拉伯)',
  'vip.menu.type': '类型',
  'vip.menu.typeWeek': '周会员',
  'vip.menu.typeMonth': '月会员',
  'vip.menu.typeYear': '年会员',
  'vip.menu.operationSuccess': '操作成功',
  'vip.menu.exportFileName': '会员菜单',
  'vip.menu.typeRequired': '类型不能为空',
  'vip.menu.unitPriceRequired': '每天单价不能为空',
  'vip.menu.totalPriceRequired': '总价不能为空',

  // VIP related - order
  'vip.order.nickName': '用户昵称',
  'vip.order.inputNickName': '请输入用户昵称',
  'vip.order.mobile': '手机号',
  'vip.order.inputMobile': '请输入手机号',
  'vip.order.email': '邮箱',
  'vip.order.inputEmail': '请输入邮箱',
  'vip.order.orderNo': '订单号',
  'vip.order.inputOrderNo': '请输入订单号',
  'vip.order.payTime': '支付时间',
  'vip.order.payMoney': '支付金额($)',
  'vip.order.inputPayMoney': '请输入支付金额',
  'vip.order.payNo': '支付单号',
  'vip.order.inputPayNo': '请输入支付单号',
  'vip.order.outTrandNo': '三方订单号',
  'vip.order.inputOutTrandNo': '请输入三方订单号',
  'vip.order.menuId': '价格菜单id',
  'vip.order.inputMenuId': '请输入价格菜单id',
  'vip.order.status': '状态',
  'vip.order.statusPending': '待支付',
  'vip.order.statusSuccess': '支付成功',
  'vip.order.statusFailed': '支付失败',
  'vip.order.exportFileName': '会员订单',
  'vip.order.userIdRequired': '用户id不能为空',
  'vip.order.orderNoRequired': '订单号不能为空',
  'vip.order.payMoneyRequired': '支付金额不能为空',
  'vip.order.statusRequired': '状态不能为空',

  // Zhuima related - taskConfig
  'zhuima.taskConfig.facebookNum': '关注Facebook账号奖励金币数',
  'zhuima.taskConfig.inputFacebookNum': '请输入关注Facebook账号奖励金币数',
  'zhuima.taskConfig.youtubeNum': '关注官方宣传账号奖励金币数',
  'zhuima.taskConfig.inputYoutubeNum': '请输入关注官方宣传账号奖励金币数',
  'zhuima.taskConfig.tiktok': '关注Tiktok账号奖励金币数',
  'zhuima.taskConfig.inputTiktok': '请输入关注Tiktok账号奖励金币数',
  'zhuima.taskConfig.openMessage': '打开消息通知奖励金币数',
  'zhuima.taskConfig.inputOpenMessage': '请输入打开消息通知奖励金币数',
  'zhuima.taskConfig.likeNum': '填写兴趣爱好奖励金币数',
  'zhuima.taskConfig.inputLikeNum': '请输入填写兴趣爱好奖励金币数',
  'zhuima.taskConfig.lookVideoOne': '观看5分钟奖励金币数',
  'zhuima.taskConfig.inputLookVideoOne': '请输入观看5分钟奖励金币数',
  'zhuima.taskConfig.lookVideoTwo': '观看10分钟奖励金币数',
  'zhuima.taskConfig.inputLookVideoTwo': '请输入观看10分钟奖励金币数',
  'zhuima.taskConfig.advertisementNum': '观看一集广告奖励金币数',
  'zhuima.taskConfig.inputAdvertisementNum': '请输入观看一集广告奖励金币数',
  'zhuima.taskConfig.maxAdvertisementNum': '每天最多看多少个广告',
  'zhuima.taskConfig.inputMaxAdvertisementNum': '请输入每天最多看多少个广告',
  'zhuima.taskConfig.exportFileName': '任务奖励配置',

  // Zhuima related - userPrize
  'zhuima.userPrize.prizeName': '奖品名称',
  'zhuima.userPrize.inputPrizeName': '请输入奖品名称',
  'zhuima.userPrize.prizeCover': '奖品图片',
  'zhuima.userPrize.openTime': '抽奖时间',
  'zhuima.userPrize.useFlag': '是否使用',
  'zhuima.userPrize.useFlagUnused': '未使用',
  'zhuima.userPrize.useFlagUsed': '已使用',
  'zhuima.userPrize.prizeId': '奖品id',
  'zhuima.userPrize.inputPrizeId': '请输入奖品id',
  'zhuima.userPrize.address': '地址',
  'zhuima.userPrize.inputAddress': '请输入地址',
  'zhuima.userPrize.exportFileName': '用户抽奖记录',
  'zhuima.userPrize.useFlagLabel': '是否使用 0-未使用 1-已使用',
  'zhuima.userPrize.inputUseFlag': '请输入是否使用 0-未使用 1-已使用',

  // Zhuima related - taskUser
  'zhuima.taskUser.facebookNum': '关注fackbook奖励金币数',
  'zhuima.taskUser.inputFacebookNum': '请输入关注fackbook奖励金币数',
  'zhuima.taskUser.isFackbook': '是否关注fackbook',
  'zhuima.taskUser.inputIsFackbook': '请输入是否关注fackbook',
  'zhuima.taskUser.youtubeNum': '关注youtube奖励金币数',
  'zhuima.taskUser.inputYoutubeNum': '请输入关注youtube奖励金币数',
  'zhuima.taskUser.isYoutube': '是否关注youtube',
  'zhuima.taskUser.inputIsYoutube': '请输入是否关注youtube',
  'zhuima.taskUser.tiktok': '关注tiktok奖励金币数',
  'zhuima.taskUser.inputTiktok': '请输入关注tiktok奖励金币数',
  'zhuima.taskUser.isTiktok': '是否关注tiktok',
  'zhuima.taskUser.inputIsTiktok': '请输入是否关注tiktok',
  'zhuima.taskUser.openMessage': '打开消息通知奖励金币数',
  'zhuima.taskUser.inputOpenMessage': '请输入打开消息通知奖励金币数',
  'zhuima.taskUser.isOpen': '是否打开消息通知',
  'zhuima.taskUser.inputIsOpen': '请输入是否打开消息通知',
  'zhuima.taskUser.likeNum': '设置爱好奖励金币数',
  'zhuima.taskUser.inputLikeNum': '请输入设置爱好奖励金币数',
  'zhuima.taskUser.isLike': '是否设置爱好',
  'zhuima.taskUser.inputIsLike': '请输入是否设置爱好',
  'zhuima.taskUser.exportFileName': '任务奖励用户记录',

  // Zhuima related - prize
  'zhuima.prize.prizeName': '奖品名称',
  'zhuima.prize.inputPrizeName': '请输入奖品名称',
  'zhuima.prize.prizeCover': '奖品图片',
  'zhuima.prize.probability': '奖品概率',
  'zhuima.prize.inputProbability': '请输入奖品概率',
  'zhuima.prize.isBan': '是否禁用',
  'zhuima.prize.prizeType': '奖品类型',
  'zhuima.prize.prizeTypeVip': '会员',
  'zhuima.prize.prizeTypePhysical': '实体奖品',
  'zhuima.prize.vipDays': '会员天数',
  'zhuima.prize.inputVipDays': '请输入会员天数',
  'zhuima.prize.exportFileName': '抽奖奖品',
  'zhuima.prize.operationSuccess': '操作成功',
  'zhuima.prize.upload': '上传',
  'zhuima.prize.selectPrizeType': '请选择奖品类型',

  // Help related
  'help.title': '标题',
  'help.titleEn': '标题(英文)',
  'help.titleCn': '标题(法语)',
  'help.titleIn': '标题(印尼语)',
  'help.content': '内容',
  'help.contentEn': '内容(英文)',
  'help.contentCn': '内容(法语)',
  'help.contentIn': '内容(印尼语)',
  'help.sort': '排序',
  'help.createTime': '创建时间',
  'help.inputTitle': '请输入标题',
  'help.inputTitleEn': '请输入标题(英文)',
  'help.inputTitleCn': '请输入标题(法语)',
  'help.inputTitleIn': '请输入标题(阿拉伯)',
  'help.inputContent': '请输入内容',
  'help.inputSort': '请输入排序',
  'help.titleRequired': '标题不能为空',
  'help.sortRequired': '排序不能为空',
  'help.add': '添加',
  'help.edit': '修改',
  'help.exportFileName': '帮助中心',

  // App title
  'app.title': 'Laqta',

  // Account dropdown
  'account.personalSettings': '个人设置',
  'account.logout': '退出登录',
  'account.logoutTitle': '提示',
  'account.confirmLogout': '确定注销并退出系统吗？'
}

